module.exports = __webpack_public_path__ + "img/plexus-8.c7e05c0a.png";